import { render } from "./TvmNavigateToInventory.vue?vue&type=template&id=39a0a112&scoped=true"
import script from "./TvmNavigateToInventory.js?vue&type=script&lang=js&external"
export * from "./TvmNavigateToInventory.js?vue&type=script&lang=js&external"

import "./TvmNavigateToInventory.vue?vue&type=style&index=0&id=39a0a112&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39a0a112"]])

export default __exports__